exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".webex-source-manager {\n  margin-bottom: 20px; }\n  .webex-source-manager .source-info {\n    color: white; }\n    .webex-source-manager .source-info .webex-logo {\n      background-image: url(" + require("./assets/webex-logo-icon.svg") + ");\n      width: 40px;\n      height: 28px;\n      background-repeat: no-repeat;\n      margin: 10px; }\n  .webex-source-manager .webex-content {\n    padding: 0 20px; }\n    .webex-source-manager .webex-content .info {\n      color: #673bb7;\n      margin: 20px 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/webex_source_manager/webex_source_manager.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/webex_source_manager/webex_source_manager.scss
// module chunks = index